import React from 'react';
import { TraderChatNotificationBar } from 'src/domains/players/webview/components/Account/traderChat/components/NotificationBar.style';
import { NotificationIcons } from 'src/domains/players/webview/components/Account/traderChat/components/NotificationIcons';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { TraderChatState } from 'src/domains/players/state/traderChat/TraderChatState';

export const ChatNightModeMessage = observer('ChatNightModeMessage', () => {
    const common = useCommon();
    const { isNightModeEnabled, nightModeMessage } = TraderChatState.get(common);

    const isNightModeActive = isNightModeEnabled === true;
    const isNightModeHasMessage = nightModeMessage !== null && nightModeMessage !== '';

    const defaultMessage = (
        <I18n
            langKey='account.trader-chat.night-mode-info'
            defaultText='We are away at the moment. Please contact support another time.'
        />
    );

    if (isNightModeActive) {
        if (isNightModeHasMessage) {
            return (
                <TraderChatNotificationBar>
                    <NotificationIcons />
                    {nightModeMessage}
                </TraderChatNotificationBar>
            );
        } else {
            return (
                <TraderChatNotificationBar>
                    <NotificationIcons />
                    {defaultMessage}
                </TraderChatNotificationBar>
            );
        }
    }
    return null;
});
